import { Component, ElementRef, OnInit, QueryList, ViewChild, ViewChildren } from '@angular/core';
import { SwModalframeComponent } from 'src/app/librarys/components/basic-components/sw-modal-frame/sw-modal-frame.component';
import { SwMassageBoxService } from 'src/app/librarys/serves/sw-massage-box.service';
import { SwJwtService } from 'src/app/librarys/serves/sw-jwt.service';
import { ActivatedRoute, Router } from '@angular/router';
import { TextMarkListComponent } from '../text-mark-list/text-mark-list.component';
import { SwTabService } from 'src/app/librarys/serves/public/sw-tab.service';
import { environment } from 'src/environments/environment';
import { SwHttpClientService } from 'src/app/librarys/serves/sw-http-client.service';
import { SwMaskService } from 'src/app/librarys/components/basic-components/sw-mask/sw-mask.service';
import { KmsService } from '../../../kms.service';
import { InstanceModuleService } from '../../../serves/instance/instance.module';
import { InstanceInfoViewComponent } from '../../../components/instance-info-view/instance-info-view.component';
import { SwCreateModalComponentService } from 'src/app/librarys/serves/sw-create-modal-component.service';
import { SwMassageConfirmComponent } from 'src/app/librarys/components/basic-components/sw-massage-confirm/sw-massage-confirm.component';

declare var $, ResizeObserver;
@Component({
  selector: 'app-new-entity-relation-mark',
  templateUrl: './new-entity-relation-mark.component.html',
  styleUrls: ['./new-entity-relation-mark.component.css']
})
export class NewEntityRelationMarkComponent implements OnInit {
  @ViewChild("trim") trim: SwMassageConfirmComponent;     //确认弹框
  // 选择实体类弹框
  @ViewChild('selectConceptModal') selectConceptModal: SwModalframeComponent;
  // 选择实体类关系弹框
  @ViewChild('selectRelationModal') selectRelationModal: SwModalframeComponent;
  // 绑定同名实体弹框
  @ViewChild('selectInstanceModal') selectInstanceModal: SwModalframeComponent;
  // 实体关系标注清单组件
  @ViewChild('textMarkList') textMarkList: TextMarkListComponent;
  // 任务信息
  taskData: any = {};
  // 是否显示左侧目录
  showLeftNav = true;
  // 左侧显示模块 0 目录及知识；1 知识融合；
  operateState = 0;
  // 左侧模块
  menus: any = [
    '目录',
    // '搜索',
    '实体',
    '关系'
  ];
  // 目录、知识模块选中索引
  selectIndex = 0;
  // 是否显示句读
  showJudou = false;
  // 标签类型 0 类；1 属性；
  tagType = 0;  
  // 可选实体类
  concepts: any = [];
  disableIds = [];
  // 可选属性
  attrs: any = [];
  // 插入标签时：选中的类
  selectedConcept:any = {};
  // 可选关系数据
  relations: any = [];
  // 用于保存的实体、关系数据
  data: any = {
    entitys: [],
    relations: []
  };
  // 页面展示时每一行的文字及已标注的实体、属性配置信息
  rowArr: any = [];
  // 页面展示时实体-关系-实体、实体-属性名-属性配置信息
  relationArr: any = [];
  // 每行最后可显示的文本长度
  maxTextLength = 0;
  // 选中文字对象
  selectTextObj = {
    text: '', 
    start: 0,
    end: 0, 
  }
  // 选中的起始节点
  startNode: any = null;
  // 选中的指向节点
  endNode: any = null;
  // 鼠标移入关系边id
  hoverRelationId = '';
  // 鼠标移入标签id
  hoverTagId = '';
  // 是否显示实体右键菜单
  showEntityQuickMenu = false;
  // 右键选中实体、属性的唯一标识
  selectEntityUuid = '';
  // 右键选中实体
  selectNode:any = {};
  // 知识库中已存在的同名实体
  sameNameInstances = [];
  // 右键选中实体的关联关系
  nodeRelations:any = [];
  // 右键选中关系的唯一标识
  selectRelationUuid = '';
  // 页号
  pageArr: any = [];
  // 操作状态
  upOrAdd = '';
  // 概念查询参数
  conceptName = '';
  // 关系查询参数
  relationName = '';
  // 资源内容页数据
  contentList:any = [];
  // 审核通过时不允许编辑
  editEnable = true;
  // 简繁转换后的数据
  transformedText = '';
  type = 2;   // 1：简体 2: 繁体
  isInit = true;
  // 实体融合：同名同概念实体信息
  sameEntityArr:any = [];
  // 是否校对过
  isCorrected = false;
  // 是否展示取消标注实体关系对话框
  showNodeRelation = false;
  // 标注清单组件传入参数
  filterConditions:any = {
    type: -1,
  };
  // 是否展示导出按钮组
  showExportBtns = false;
  constructor(
    private create: SwCreateModalComponentService,
    private http: SwHttpClientService,
    private tabService: SwTabService,
    private router: Router,
    private jwt: SwJwtService,
    private kmsService: KmsService,
    private message: SwMassageBoxService,
    private instanceModuleService: InstanceModuleService,
    private activatedRouter: ActivatedRoute,
    private swMaskService: SwMaskService
  ) { }

  ngOnInit() {
    // 屏蔽右侧菜单事件
    const element = document.getElementsByClassName('rightMarkCon')[0];
    element.addEventListener('contextmenu', function(e) {
      e.preventDefault();
    });

    this.activatedRouter.queryParams.subscribe((param) => {
      this.upOrAdd = param.upOrAdd;
      this.taskData = JSON.parse(param.selectData);
      this.getMarkData();
    });
  }

  // 通过任务主键id查询文本标注数据
  getMarkData() {    
    this.kmsService.getKeTaskById(this.taskData.taskId).subscribe(
      res => {
        if (res["code"] == '200') {
          // 获取任务信息
          this.taskData = res.data;
          const obj = JSON.parse(res.data.jsonStr);
          // 判断当前抽取结果是否进行编辑，抽取完成且未同步到知识库才允许进行编辑
          this.editEnable = !this.checkDisable();
          if(!obj.fulltext){
            return;
          }
          // 获取分页内容信息
          this.contentList = obj.contentList;
          // 获取全文内容
          const fulltext = obj.fulltext;
          this.transformedText = fulltext;
          this.taskData.fulltext = fulltext;
          // 根据分页内容信息中的起始结束位置，获取每一页文本
          this.taskData.documentTextArr = [];
          let documentTextArr = [];
          this.contentList.forEach(e => {
            documentTextArr.push(fulltext.slice(e.start,e.end));
          })
          this.taskData.documentTextArr = documentTextArr;
          // 将标注数据转换成当前所需格式
          // 1.若obj.result为空，说明还未进行人工校对，需要从分页内容信息中获取单页抽取结果进行合并展示
          if(!obj.result){
            this.data = this.mergePageExtractResult();
            this.isCorrected = false;
          }
          // 2.若obj.result不为空，说明已进行人工校对，需要从obj.result中获取已合并的全文抽取结果并展示
          else{
            this.data = obj.result;
            this.isCorrected = true;
          }
          this.taskData.documentMarkJson = JSON.stringify(this.data);
          this.init();
        }
      }
    )
  }

  // 遍历内容信息中的每一页获取抽取结果，并合并展示
  mergePageExtractResult(){
    let allEntities = [], allRelations = [];
    this.contentList.forEach((e,i) => {
      // 判断当前页是否抽取完成，且有抽取结果
      if(e.status == 2 && e.result && e.result.entities.length>0){
        let entities = e.result.entities, relations = e.result.relations, attributes = e.result.attributes, pageText = this.taskData.documentTextArr[i];
        let newEntities = [], newRelations = [];
        const offset = i > 0 ? this.contentList[i-1].end : 0;
        // 将抽取出的实体、属性、关系数据，转换成当前所需格式
        // 1.处理实体信息
        entities.forEach(e => {
          let isOutRange = false;
          const start = pageText.indexOf(e.text);
          if(start < 0){
            isOutRange = true;
          }
          if(!e.type || !e.conceptId){
            isOutRange = true;
          }
          newEntities.push({
            "tagType": 0,  
            "name": e.text,
            "start": start+1+offset,     // 起始和结束位置需加上相对于全文的偏移量
            "end": start+1+e.text.length+offset,   
            "conceptId": e.conceptId,  
            "conceptName": e.type,  
            "conceptCode": e.conceptCode,
            "mapping": e.mapping,
            "uuid": this.instanceModuleService.uuid2(),
            "isOutRange": isOutRange
          });
        });

        // 2.处理实体-关系信息
        if(relations && relations.length > 0){
          relations.forEach(e => {
            if(newEntities[e.subject] && newEntities[e.object]){
              newRelations.push({
                "tagType": 0,  
                "startNodeName": newEntities[e.subject].name,
                "endNodeName": newEntities[e.object].name,
                "startNodeId": newEntities[e.subject].uuid,
                "endNodeId": newEntities[e.object].uuid,
                "uuid": this.instanceModuleService.uuid2(),
                "relationshipId": e.relationshipId,
                "relationName": e.relation,
                "relationAlias": e.relationAlias,
                "relationshipName": e.relationshipName,
                "reverseRelationAlias": e.reverseRelationAlias,
                "reverseRelationName": e.reverseRelationName,
                "sourceList": [
                  {
                    materialId: e.materialId,
                    pageNum: e.pageNum,
                    sourceMaterial: e.sourceMaterial,
                  }
                ],
                "isOutRange": newEntities[e.subject].isOutRange || newEntities[e.object].isOutRange
              })
            }
          })
        }

        // 3.处理实体-属性信息
        if(attributes && attributes.length > 0){
          attributes.forEach(e => {
            if(newEntities[e.entity]){
              const start = pageText.indexOf(e.value);
              const uuid = this.instanceModuleService.uuid2();
              newEntities.push({
                "tagType": 1,  
                "name": e.value,
                "start": start+1+offset,     // 起始和结束位置需加上相对于全文的偏移量
                "end": start+1+e.value.length+offset,   
                "conceptId": newEntities[e.entity].conceptId,  
                "conceptName": newEntities[e.entity].conceptName,  
                "attributeId": e.relationshipId,
                "attributeName": e.relationshipName,
                "englishCode": e.englishCode,
                "sortNum": e.sortNum,
                "sourceList": [
                  {
                    materialId: e.materialId,
                    pageNum: e.pageNum,
                    sourceMaterial: e.sourceMaterial,
                  }
                ],
                "color": '#666666',
                "bgColor": '#dddddd',
                "uuid": uuid,
                "isOutRange": newEntities[e.entity].isOutRange  || start < 0
              });
              newRelations.push({
                "tagType": 1,  
                "startNodeName": newEntities[e.entity].name,
                "endNodeName": e.value,
                "startNodeId": newEntities[e.entity].uuid,
                "endNodeId": uuid,
                "uuid": this.instanceModuleService.uuid2(),
                "relationshipId": e.relationshipId,
                "relationName": e.relationshipName,
                "isOutRange": newEntities[e.entity].isOutRange  || start < 0
              })
            }
          })
        }
        // 过滤掉超出文本范围的实体、关系
        newEntities = newEntities.filter(e => !e.isOutRange);
        newRelations = newRelations.filter(e => !e.isOutRange);
        newEntities.forEach(e => {
          delete e.isOutRange;
        });
        newRelations.forEach(e => {
          delete e.isOutRange;
        });
        
        // 将同一位置多次出现的实体合并
        const mergeData = this.mergeSameEntity(newEntities,newRelations);
        newEntities = mergeData.entitys;
        newRelations = mergeData.relations;

        // 合并到总数据中
        allEntities = allEntities.concat(newEntities);
        allRelations = allRelations.concat(newRelations);
      }
    })
    return {
      entitys: allEntities,
      relations: allRelations
    }
  }

  // 将实体数组中name和start相同的合并成一条数据，关系数组中用到该实体的同步进行修改
  mergeSameEntity(entitys,relations){
    // 合并实体数组
    const mergedEntities = [];
    const uuidMap = {};

    entitys.forEach((entity) => {
      const key = `${entity.name}-${entity.start}-${entity.conceptId}-${entity.tagType}`;
      if (!uuidMap[key]) {
        mergedEntities.push(entity);
        uuidMap[key] = entity.uuid;
      } else {
        // 如果已经存在，更新 uuidMap
        uuidMap[entity.uuid] = uuidMap[key];
      }
    });

    // 更新关系数组
    const updatedRelations = relations.map((relation) => {
      const updatedStartNodeId = uuidMap[relation.startNodeId] || relation.startNodeId;
      const updatedEndNodeId = uuidMap[relation.endNodeId] || relation.endNodeId;
      return {
        ...relation,
        startNodeId: updatedStartNodeId,
        endNodeId: updatedEndNodeId,
      };
    });
    return {
      entitys: mergedEntities,
      relations: updatedRelations,
    };
  }

  // 获取字符串中某个字符出现的所有位置
  getCharIndex(str, char) {
    const indexArr = [];
    let index = str.indexOf(char);  // 第一次出现的位置
    while (index !== -1) {
      indexArr.push(index);
      index = str.indexOf(char, index + 1); // 从下一个位置开始继续查找
    } 
    return indexArr;
  }

  // 切换显示左侧目录+搜索模块
  toggleLeftNav() {
    this.showLeftNav = !this.showLeftNav;
    setTimeout(() => {
      this.widthResize();
    },500);
  }

  // 清除变量
  widthResize() {
    this.rowArr = []
    this.relationArr = [];
    this.maxTextLength = 0;
    this.selectTextObj = {
      text: '', 
      start: 0,
      end: 0, 
    }
    this.startNode = null;
    this.endNode = null;
    this.hoverRelationId = '';
    this.hoverTagId = '';
    this.showEntityQuickMenu = false;
    this.selectEntityUuid = '';
    this.selectRelationUuid = '';
    this.pageArr = [];
    this.init();
  }

  // 下载excel
  downloadExcel() {
    if(!this.isCorrected){
      this.message.info('请先进行人工校对！');
      return;
    }
    if (this.data.entitys.length == 0) {
      this.message.info('当前文本中未标注出任何实体关系！');
      return;
    }
    this.kmsService.exportExcelByTaskId({taskId: this.taskData.taskId, taskNum: this.taskData.taskNum});
  }

  // 下载json
  async downloadJson() {
    if (this.data.entitys.length == 0) {
      this.message.info('当前文本中未标注出任何实体关系！');
      return;
    }
    const url = environment.staticFileUrl + this.taskData.jsonPath;
    const response = await fetch(url);
    if (response.ok) {
      const blob = await response.blob();
      const link = document.createElement('a');
      link.href = window.URL.createObjectURL(blob);
      link.download = this.taskData.taskNum + '.json';
      link.click();
    } else {
      console.error('Failed to download JSON.');
    }
  }

  // 查看图谱
  viewGraph() {
    if (this.data.entitys.length == 0) {
      this.message.info('当前文本中未标注出任何实体关系！');
      return;
    }
    const params = {
      taskId: this.taskData.taskId,
      taskNum: this.taskData.taskNum
    }
    this.router.navigate(['/kms/GraphView'], { queryParams: { Title: '查看图谱', selectData: JSON.stringify(params) } });
  }

  // 返回
  back() {
    this.tabService.closeUrl('/kms/EntityRelationMark', true);
  }

  // 按照当前格式（繁简），返回指定位置的数据
  clickTransformText(i) {
    const obj = this.rowArr[i];
    const text = this.transformedText.slice(obj.start,obj.end);
    return text;
  }

  // 查看原文
  clickReadSource(){
    this.transformedText = this.taskData.fulltext;
  }
  
  // 初始化
  init(){
    this.splitTextIntoLines();
    if(this.concepts.length == 0){
      // 获取所有可选类
      this.getAllConcepts();
    }else{
      setTimeout(() => {
        this.drawEntityRelation();
      },500);
    }
  }

  // 查询所有的可选概念
  getAllConcepts(){
    this.kmsService.getConceptTreeData({}).subscribe(
      res => {
          if (res.code == 200) {
            this.concepts = [];
            this.http.Get('assets/kgs/conceptColorConfig.json').subscribe((data) => {
              let colorConfig = data;
              let arr = [];
              res.data.forEach(e => {
                let colorObj:any = colorConfig[e.name];
                if(!colorObj){
                  colorObj = {
                    "color": "rgb(100, 100, 100)",
                    "bgColor": "rgba(100, 100, 100, 0.3)"
                  }
                }
                e.conceptId = e.id;
                e.conceptName = e.name;
                e.color = colorObj.color;
                e.bgColor = colorObj.bgColor;
                arr.push(e);
                if(res.data.filter(e1 => e1.parentId == e.id).length > 0){
                  this.disableIds.push(e.id);
                }
              })
              this.concepts = arr;
              this.data.entitys.forEach(e => {
                if(e.tagType === 0){
                  e.color = colorConfig[e.conceptName] ? colorConfig[e.conceptName].color : "rgba(100, 100, 100)";
                  e.bgColor = colorConfig[e.conceptName] ? colorConfig[e.conceptName].bgColor : "rgba(100, 100, 100, 0.3)";
                }
              })
              setTimeout(() => {
                this.drawEntityRelation();
              },0);
            });
          }
        }
    );
  }

  // 将长文本拆分成多个刚好占满容器宽度的子串
  splitTextIntoLines(){
    // 创建一个隐藏的canvas元素用于测量文本宽度
    let canvas = document.createElement('canvas');
    let ctx = canvas.getContext('2d');
    ctx.font = '15px 微软雅黑';
    // 测量文本宽度并计算一行最多可放入的文本长度
    let container = document.getElementById('textContainer');
    let divWidth = container.offsetWidth - 24;
    let charWidth = ctx.measureText("十").width;
    this.maxTextLength = Math.floor(divWidth / charWidth);
    // 首先将文本按照分页符拆分成不同的组
    let pageTextArr = this.taskData.documentTextArr;
    let textArr = [];
    this.pageArr = [];
    pageTextArr.forEach(t => {
      if(t){
        // 根据</p>拆分成不同的段落
        let rowTextArr = t.replace(new RegExp('<p>', 'g'), '').split('</p>');
        rowTextArr.forEach((r,i) => {
          if(r){
            if(i == 0){
              const pageI = this.pageArr.length;
              this.pageArr.push({
                rowI: textArr.length,
                pageI: pageI
              });
            }
            // 将每个段落按照maxTextLength，拆分成不同的行
            const arr = this.splitTextToSubTexts(r,this.maxTextLength);
            textArr = textArr.concat(arr);
          }
        });
      }
    });
    textArr.forEach((e,i) => {
      const start = i == 0 ? 0 : this.rowArr[i-1].end;
      const end = start + e.length;
      this.rowArr.push({
        text: e,
        start: start,
        end: end,
        paddingTop: 18,
        tags: []
      })
    });
  }

  // 将字符串按照长度为 n 拆分成若干个子串
  splitTextToSubTexts(str,n){
    let result = str.split('').reduce((acc, char, index) => {
      if (index % n === 0) {
          acc.push('');
      }
      acc[acc.length - 1] += char;
      return acc;
    }, []);
    return result;
  }

  // 选择文字
  addEnityTag(event,i){
    const selection = window.getSelection();
    if (selection && selection.rangeCount > 0) {
      // 获取所选的文字内容
      const selectText = selection.toString();
      if(!selectText){
        return;
      }
      if(!this.editEnable){
        if(this.taskData.status !== 3){
          this.message.info('当前任务下的文档未抽取完成，不允许编辑！');
        }else{
          this.message.info('当前任务下标注的实体关系已发布至知识库，不允许编辑！');
        }
        return;
      }
      // 将selectText以\n为分隔符拆分成数组，大于0，说明跨行选择文字；
      const arr = selectText.split('\n');
      // 跨行选择文字时，行号、页码、类及属性标签名称也会被选中，因此不能直接用selectText过滤\n获取filterText
      // const filterText = selectText.replace(/\n/g,'');
      // 获取选择的文字范围
      let range = selection.getRangeAt(0);
      const startI = range.startOffset;
      const endI = range.endOffset;
      // 当所选文字处于同一行时
      if(arr.length == 1){
        const filterText = this.rowArr[i].text.slice(startI-1,endI-1);
        this.selectTextObj = {
          text: filterText,
          start: (i > 0 ? this.rowArr[i-1].end : 0) + startI, 
          end: (i > 0 ? this.rowArr[i-1].end : 0) + endI
        }
      }
      // 当所选文字处于多行时
      else{
        let filterText = '';
        const i1 = i-(arr.length-1);
        this.rowArr.forEach((r,rI) => {
          if(rI == i1){
            filterText += r.text.slice(startI-1,);
          }else if(rI > i1 && rI < i){
            filterText += r.text;
          }else if(rI == i){
            filterText += r.text.slice(0,endI-1);
          }else{
          }
        });
        this.selectTextObj = {
          text: filterText,
          start: (i1 > 0 ? this.rowArr[i1-1].end : 0) + startI, 
          end: (i > 0 ? this.rowArr[i-1].end : 0) + endI
        }
      }
      // 打开选择实体类弹框
      this.selectConceptModal.toggle();
    }
  }

  // 点击选择实体类
  clickSelectConcept(item) {
    this.selectedConcept = item.data;
    // 当前插入的是实体标签
    if(this.tagType == 0){
      // 关闭选择实体类弹框
      this.selectConceptModal.toggle();
      setTimeout(() => {
        const entity = this.selectTextObj;
        this.data.entitys.push({
          tagType: 0,  // 实体
          name: entity.text,
          start: entity.start,
          end: entity.end,
          conceptId: this.selectedConcept.conceptId,
          conceptName: this.selectedConcept.conceptName,
          conceptCode: this.selectedConcept.code,
          mapping: this.selectedConcept.mapping,
          color: this.selectedConcept.color,
          bgColor: this.selectedConcept.bgColor,
          uuid: this.instanceModuleService.uuid2()
        })
        this.drawEntityRelation();
        // 保存json信息
        this.saveTaskMarkData();
      },0);
    }
    // 当前插入的是属性标签，需要根据选择的类，查询类的属性
    else{
      this.queryAttrsByConceptId();
    }
  }

  // 点击选择属性
  clickSelectAttr(attr){
    // 关闭选择实体类弹框
    this.selectConceptModal.toggle();
    setTimeout(() => {
      const entity = this.selectTextObj;
      // 根据start计算所在页
      let materialInfo:any = this.findInterval(entity.start-1,this.contentList);
      this.data.entitys.push({
        tagType: 1, // 属性
        name: entity.text,
        start: entity.start,
        end: entity.end,
        conceptId: this.selectedConcept.conceptId,
        conceptName: this.selectedConcept.conceptName,
        attributeId: attr.attributeId,
        attributeName: attr.attributeName,
        englishCode: attr.englishCode,
        sortNum: attr.sortNum,
        sourceList: [
          {
            materialId: materialInfo.materialId,
            pageNum: materialInfo.pagesNum,
            sourceMaterial: materialInfo.materialTitle,
          }
        ],
        color: '#666666',
        bgColor: '#dddddd',
        uuid: this.instanceModuleService.uuid2()
      })
      this.drawEntityRelation();
      // 保存json信息
      this.saveTaskMarkData();
    },0);
  }

  findInterval(x, intervals) {
    for (let i = 0; i < intervals.length; i++) {
        const interval = intervals[i];
        if (x >= interval.start && x < interval.end) {
            return interval;
        }
    }
    return {};
  }

  // 选择当前标记的文本类型：类 、 属性
  selectType(type){
    this.tagType = type;
    if(this.selectedConcept.conceptId){
      this.queryAttrsByConceptId();
    }
  }

  // 查询类的属性
  queryAttrsByConceptId(){
    const id = this.selectedConcept.conceptId;
    this.kmsService.getAttributeForForm(id).subscribe(
      res => {
        if (res.code == '200') {
          // 渲染基本信息表格
          this.attrs = res.data.commonAttributes.sort(function(a,b){
            return a.sortNum - b.sortNum
          });
        }
      }
    )
  }

  // 绘制实体、属性标签、关系连线
  drawEntityRelation(){
    this.rowArr.forEach(e => {
      e.paddingTop = 18;
      e.tags = [];
    });
    // 绘制实体、属性标签
    if(this.data.entitys.length>0){
      this.data.entitys.forEach(e => {
        // start、end都是从1开始计数；start为选中文字的起始位置;end为选中文字的结束位置，end比最后一个字符的位置多1；end = start + text.length;
        // 根据start、end计算起始字和结束字所在行;行信息里start、end从0开始
        const startRow = this.findZiInRow(e.start - 1);
        const endRow = this.findZiInRow(e.end - 2);
        const startRowObj = this.rowArr[startRow];
        const endRowObj = this.rowArr[endRow];
        // 如果当前实体标签对应文字处于同一行
        if(startRow == endRow){
          const s = startRowObj.start;
          this.addEntityToRow(e,startRow,e.start-s,e.end-1-s);
        }else{
          // 计算选中文字出现在哪些行，以及每一行对应的起始、结束位置
          let len = endRow - startRow;
          for(let i = 0;i <= len;i++){
            if(i == 0){
              const s = startRowObj.start;
              this.addEntityToRow(e,startRow+i,e.start-s,startRowObj.text.length);
            }
            if(i > 0 && i < len){
              const obj = this.rowArr[startRow+i];
              this.addEntityToRow(e,startRow+i,0,obj.text.length);
            }
            if(i == len){
              const s = endRowObj.start;
              this.addEntityToRow(e,startRow+i,0,e.end-1-s);
            }
          }
        }
      });
    }
    // 绘制关系连线
    setTimeout(() => {
      this.drawRelation();
    },800);
  }

  // 根据字在整段文本的索引查询字所在的行
  findZiInRow(i){
    let rowI = 0;
    this.rowArr.forEach((e,j) => {
      if(i >= e.start && i < e.end){
        rowI = j;
      }
    });
    return rowI;
  }

  // 判断两个数值区间是否有交集
  hasIntersection(range1, range2) {
    let [a1, a2] = range1;
    let [b1, b2] = range2;
    return b1 <= a2 && a1 <= b2;
  }

  // 在某一行指定区域内添加实体、属性标签
  addEntityToRow(d,i,startIndex,endIndex){
    // 获取div元素中指定位置字的坐标
    const p1 = this.getZiPosition(i,startIndex);
    const p2 = this.getZiPosition(i,endIndex+1);
    // // 判断当前行内选中文字区域内是否已经标注过实体、属性
    // let rBottom = 0;
    // this.rowArr[i].tags.forEach(t => {
    //   // 判断两个数值区间是否有交集
    //   if(this.hasIntersection([p1.x,p2.x],[t.left,t.left+t.width])){
    //     rBottom = t.bottom > rBottom ? t.bottom : rBottom;
    //   }
    // });
    // this.rowArr[i].tags.push({
    //   id: d.uuid,
    //   left: p1.x,
    //   width: p2.x - p1.x,
    //   bottom: rBottom > 0 ? rBottom + 30 : 40,
    //   tag: d
    // });

    let tagArr = JSON.parse(JSON.stringify(this.rowArr[i].tags));
    // 首先，使用 sort 方法对数组进行排序，根据 bottom 的值从小到大排列
    tagArr.sort((a, b) => a.bottom - b.bottom);
    // 然后，使用 reduce 方法将数组分组到不同的子数组中
    let result = tagArr.reduce((acc, cur) => {
        let lastSubArray = acc[acc.length - 1];
        if (lastSubArray && lastSubArray[0].bottom === cur.bottom) {
            lastSubArray.push(cur);
        } else {
            acc.push([cur]);
        }
        return acc;
    }, []);
    let rBottom = 0, hasIntersectionOn = true;
    result.forEach((e,i) => {
      if(hasIntersectionOn){
        hasIntersectionOn = false
        e.forEach(t => {
          if(this.hasIntersection([p1.x,p2.x],[t.left,t.left+t.width])){
            hasIntersectionOn = true;
          }
        });
        rBottom = e[0].bottom;
        if(hasIntersectionOn && i == result.length-1){
          rBottom = e[0].bottom + 30;
        }
      }
    });

    this.rowArr[i].tags.push({
      id: d.uuid,
      left: p1.x,
      width: p2.x - p1.x,
      bottom: rBottom > 0 ? rBottom : 40,
      tag: d
    });
    // 重新获取当前行的paddingTop值
    let arr = this.rowArr[i].tags.sort((a,b) => {return b.bottom - a.bottom});
    this.rowArr[i].paddingTop = arr.length == 1 ? 30 : arr[0].bottom;
  }

  // 获取div元素中指定位置字的坐标
  getZiPosition(i,n){
    let parentDiv = document.getElementById('textRow-'+i);
    let range = document.createRange();
    range.setStart(parentDiv.firstChild, n);
    range.setEnd(parentDiv.firstChild, n + 1);
    let rects = range.getClientRects();
    let rect = rects[0];
    let parentRect = parentDiv.getBoundingClientRect();
    let x = rect.left - parentRect.left;
    let y = rect.top - parentRect.top;
    return {x:x,y:y};
  }

  // 绘制关系连线
  drawRelation(){
    // 更新标注清单
    this.updateMarkList();
    // 绘制线条
    this.relationArr = [];
    let relations = JSON.parse(JSON.stringify(this.data.relations));
    if(relations.length == 0){
      return;
    }
    try {
      // 关系容器高度
      const p0 = $('.relationContainer').offset();
      // 实体标签容器高度
      const h = 28;  
      relations.forEach(e => {
        // 起始实体标签的偏移量、宽高
        const startSpan = $("span[id^='entity-"+e.startNodeId+"']:last");
        const p1 = startSpan.offset();
        const w1 = startSpan.width();
        const h1 = startSpan.height();
        // 起始实体标签的偏移量、宽高
        const endSpan = $("span[id^='entity-"+e.endNodeId+"']:last");
        const p2 = endSpan.offset();
        const w2 = endSpan.width();
        const h2 = endSpan.height();
        // 获取svg容器的宽高、位置
        let cW,cH,cLeft,cTop;
        // 获取起始点、指向点的坐标
        let x1,x2,y1,y2,mX1,mY1,mX2,mY2;
        // 起始点、指向点在同一行
        if(p1.top == p2.top){
          if(p1.left <= p2.left){
            cW = p2.left + (w2/2) - p1.left - (w1/2) + 20;
            cLeft = p1.left + w1/2 - p0.left - 10;
          }else{
            cW = p1.left + (w1/2) - p2.left - (w2/2) + 20;
            cLeft = p2.left + w2/2 - p0.left - 10;
          }
          cH = 20;
          cTop = p1.top - p0.top - 20;
          e['svgRect'] = {
            width: cW,
            height: cH,
            left: cLeft,
            top: cTop
          }
  
          x1 = p1.left + w1/2 - p0.left - cLeft;
          x2 = p2.left + w2/2 - p0.left - cLeft;
          y1 = p1.top - p0.top - cTop;
          y2 = p1.top - p0.top - cTop;
          mX1 = x1;
          mY1 = y1 - 20;
          mX2 = x2;
          mY2 = y2 - 20;
          // 获取指向点箭头路径
          e['endArrowPath'] = 'M'+x2+','+y2+' '+
                                'L'+(x2 - 4)+','+(y2 - 8)+' '+
                                'L'+(x2 + 4)+','+(y2 - 8);
          // 获取线段路径
          e['linePath'] = 'M'+x1+','+y1+' '+
                            'L'+mX1+','+mY1+' '+
                            'L'+mX2+','+mY2+' '+
                            'L'+x2+','+y2;
          // 获取关系文字坐标  放在指向节点附近
          e['textPoint'] = {
            x: (x1 + x2)/2,
            y: y1 - 10,
            width: e.relationName.length*15
          }
        }else{
          if(p1.left <= p2.left){
            if(p1.left + w1 >= p2.left){
              cW = p2.left - p1.left - w1 + 20 + 100;
            }else{
              cW = p2.left - p1.left - w1 + 20;
            }
            cLeft = p1.left + w1 - p0.left - 10;
          }else{
            if(p2.left + w2 >= p1.left){
              cW = p1.left - p2.left - w2 + 20 + 100;
              cLeft = p2.left + w2- p0.left - 10 - 100;
            }else{
              cW = p1.left - p2.left - w2 + 20;
              cLeft = p2.left + w2- p0.left - 10;
            }
          }
          if(p1.top <= p2.top){
            cH = p2.top - p1.top + h + 20;
            cTop = p1.top - p0.top - 10;
          }else{
            cH = p1.top - p2.top + h + 20;
            cTop = p2.top - p0.top - 10;
          }
          e['svgRect'] = {
            width: cW,
            height: cH,
            left: cLeft,
            top: cTop
          }
          if(p1.left <= p2.left){
            x1 = p1.left + w1 - p0.left - cLeft;
            if(p1.left + w1 >= p2.left){
              x2 = p2.left + w2 - p0.left - cLeft;
            }else{
              x2 = p2.left - p0.left - cLeft;
            }
          }else{
            x1 = p1.left - p0.left - cLeft;
            if(p2.left + w2 >= p1.left){
              x2 = p2.left - p0.left - cLeft;
            }else{
              x2 = p2.left + w2 - p0.left - cLeft;
            }
          }
          y1 = p1.top - p0.top - cTop + h1/2;
          y2 = p2.top - p0.top - cTop + h2/2;
          // 获取转折点的坐标
          mX1 = (x1 + x2)/2;
          mY1 = y1;
          mX2 = (x1 + x2)/2;
          mY2 = y2;
          // x1、x2间隔较小需额外处理
          let isRithtArrow = x1 < x2;
          if(Math.abs(x1 - x2) <= 80){
            if(p1.left <= p2.left){
              if(p1.left + w1 >= p2.left){
                mX1 = x2 + 50;
                mX2 = mX1;
                isRithtArrow = false;
              }
            }else{
              if(p2.left + w2 >= p1.left){
                isRithtArrow = true;
                e['svgRect'].left = e['svgRect'].left - 50;
                x1 = x1 + 50;
                x2 = x2 + 50;
                mX1 = x2 - 50;
                mX2 = mX1;
              }
            }
            e['svgRect'].width = 150;
          }
          // 获取指向点箭头路径
          if(isRithtArrow){
            e['endArrowPath'] = 'M'+x2+','+y2+' '+
                                'L'+(x2 - 8)+','+(y2 + 4)+' '+
                                'L'+(x2 - 8)+','+(y2 - 4);
          }else{
            e['endArrowPath'] = 'M'+x2+','+y2+' '+
                                  'L'+(x2 + 8)+','+(y2 + 4)+' '+
                                  'L'+(x2 + 8)+','+(y2 - 4);
          }
          // 获取线段路径
          e['linePath'] = 'M'+x1+','+y1+' '+
                           'L'+mX1+','+mY1+' '+
                           'L'+mX2+','+mY2+' '+
                           'L'+x2+','+y2;
          // 获取关系文字坐标  放在指向节点附近
          if(y1 >= y2){
            e['textPoint'] = {
              x: mX1,
              y: y2 + 16,
              width: e.relationName.length*15
            }
          }else{
            e['textPoint'] = {
              x: mX1,
              y: y2 - 16,
              width: e.relationName.length*15
            }
          }
        }
      });
      this.relationArr = relations;
      this.isInit = false;
    } catch (error) {
      console.error('发生错误:', error.message);
    }
  }

  // 点击选择某个已标注的实体或属性
  clickSelectTag(event,item){
    if(!this.editEnable){
      if(this.taskData.status !== 3){
        this.message.info('当前任务下的文档未抽取完成，不允许编辑！');
      }else{
        this.message.info('当前任务下标注的实体关系已发布至知识库，不允许编辑！');
      }
      return;
    }
    //禁止冒泡
    event.stopPropagation();
    // 左键
    if (event.button === 0) {
      if(!this.startNode){
        // 设置标签选中状态
        let spanEles = $("span[id^='entity-"+item.tag.uuid+"']");
        spanEles.each(function(){
          $(this).addClass('active');
        });
        // 设置起始节点
        this.startNode = item.tag;
      }else{
        // 判断当前选择的两个标注项是否都是实体
        if(this.startNode.tagType == 0 && item.tag.tagType == 0){
          // 判断重名
          if(this.startNode['name'] == item.tag['name']){
            this.message.info('同名实体不允许创建关系！');
            // 清除标签选中效果
            this.emptyActive();
            // 清空选中项
            this.startNode = null;
            this.endNode = null;
            return;
          }
          // 设置标签选中状态
          let spanEles = $("span[id^='entity-"+item.tag.uuid+"']");
          spanEles.each(function(){
            $(this).addClass('active');
          });
          // 设置指向节点
          this.endNode = item.tag;
          // 查询概念属性关系
          const params = {
            sourceConceptId: this.startNode.conceptId,
            targetConceptId: this.endNode.conceptId,
          }
          this.kmsService.getRelationTreeListPrefix(params).subscribe(
            res => {
              if(res.code == 200){
                this.relations = res.data;
                // 判断是否存在关系
                if(this.relations.length <= 1){
                  this.message.info('实体类“'+this.startNode.conceptName+'”和“'+this.endNode.conceptName+'”之间未配置关系！');
                  // 清除标签选中效果
                  this.emptyActive();
                  // 清空选中项
                  this.startNode = null;
                  this.endNode = null;
                }else{
                  let arr = [];
                  this.relations.forEach(el => {
                    if (this.relations.filter(e11 => e11.parentId == el.id).length == 0) {
                      el.attributeName = el.relationAlias || el.name;
                      arr.push(el);
                    }
                  })
                  this.relations = arr;
                  // 打开选择实体关系弹框
                  this.relationName = '';
                  this.selectRelationModal.toggle();
                }
              }
            }
          )
        }
        // 判断当前选择的两个标注项是否都是属性值
        else if(this.startNode.tagType == 1 && item.tag.tagType == 1){
          this.message.info('属性和属性之间不允许创建关系！');
          // 清除标签选中效果
          this.emptyActive();
          // 清空选中项
          this.startNode = null;
          this.endNode = null;
          return;
        }else{
          if(this.startNode.conceptId != item.tag.conceptId){
            if(this.startNode.tagType == 1){
              this.message.info('属性'+this.startNode.attributeName+'不属于'+item.tag.conceptName+'！');
            }else{
              this.message.info('属性'+item.tag.attributeName+'不属于'+this.startNode.conceptName+'！');
            }
            // 清除标签选中效果
            this.emptyActive();
            // 清空选中项
            this.startNode = null;
            this.endNode = null;
            return;
          }
          this.endNode = item.tag;
          if(this.startNode.tagType == 1){
            let t = this.startNode;
            this.startNode = this.endNode;
            this.endNode = t;
          }
          const item1 = {
            tagType: 1,
            startNodeName: this.startNode['name'],
            endNodeName: this.endNode['name'],
            startNodeId: this.startNode.uuid,
            endNodeId: this.endNode.uuid,
            uuid: this.instanceModuleService.uuid2(),
            relationshipId: this.endNode.attributeId,
            relationName: this.endNode.attributeName
          };
          this.data.relations.push(item1);
          this.drawRelation();
          // 保存json信息
          this.saveTaskMarkData();
          // 清除标签选中效果
          this.emptyActive();
          // 清空选中项
          this.startNode = null;
          this.endNode = null;
        }
      }
    } 
    // 右键
    else if (event.button === 2) {
      const uuid = item.tag.uuid;
      // 获取当前点击的节点的类型
      this.selectNode = item.tag;
      // 获取当前点击的节点的所有关联关系
      this.nodeRelations = this.data.relations.filter(r => r.startNodeId == uuid || r.endNodeId == uuid);

      const p0 = $('.rightMarkCon').offset();
      // 使用属性选择器获取id以指定字符开头的最后一个元素
      // let target = $("span[id^='entity-"+item.tag.uuid+"']:last");
      let target = $(event.target);
      const p1 = target.offset();
      let left = p1.left - p0.left;
      if(left + 160 > $('.rightMarkCon').width()){
        left = $('.rightMarkCon').width() - 120;
      }
      let top = p1.top - p0.top + $('.rightMarkCon').scrollTop() + 35;
      this.showEntityQuickMenu = true;
      this.searchEntity();
      this.selectEntityUuid = uuid;
      setTimeout(() => {
        $('#entityQuickMenu').css({
          left: left+'px',
          top: top+'px'
        });
      },0);
    }
  }

  // 清除所有标签的选中效果
  emptyActive(){
    let spans = $('#textContainer span.active');
    spans.each(function(){
      $(this).removeClass('active');
    })
  }

  // 取消选择实体类
  cancelSelectConcept(){
    // 关闭选择实体类弹框
    this.selectConceptModal.toggle();
  }

  // 在知识库搜索该实体
  searchEntity(){
    if(this.selectNode.tagType == 1){
      return;
    }
    this.sameNameInstances = [];
    // 查询同名实体列表
    this.kmsService.getInstanceQueryList(
      {
        instanceName: this.selectNode.name,
        conceptId: this.selectNode.conceptId,
        isDelete: false,
        current: 1,
        size: 1000
      }
    ).subscribe(
      res => {
        if(res.code == 200){
          let data = res.data.records ? res.data.records : [];
          data = data.filter(e => e.instanceName == this.selectNode.name);
          if(data.length > 0){
            this.sameNameInstances = data;
          }
        }
      }
    )
  }

  // 查看同名实体列表
  viewSameNameEntity(){
    if(this.sameNameInstances.length == 0){
      return;
    }
    if(this.selectNode.instanceId){
      let i = this.sameNameInstances.find(e => e.instanceId == this.selectNode.instanceId);
      if(!i){
        this.message.info('绑定同名实体已被删除，请重新绑定。');
      }
    }
    this.showEntityQuickMenu = false;
    this.selectInstanceModal.toggle();
  }

  // 清除绑定的同名实体
  clearBindEntity(){
    this.showEntityQuickMenu = false;
    this.selectNode.instanceId = '';
    this.data.entitys.forEach(e => {
      if(e.uuid == this.selectEntityUuid){
        e.instanceId = '';
      }
    });
    this.drawEntityRelation();
    // 保存json信息
    this.saveTaskMarkData();
  } 

  // 选择绑定实体
  selectInstance(item){
    this.data.entitys.forEach(e => {
      if(e.uuid == this.selectEntityUuid){
        e.instanceId = item.instanceId;
      }
    });
    this.selectInstanceModal.toggle();
    this.drawEntityRelation();
    // 保存json信息
    this.saveTaskMarkData();
  }

  // 取消绑定实体
  cancelSelectInstance(){
    this.selectInstanceModal.toggle();
  }

  // 查看实体详情
  viewDetail(data){
    event.stopPropagation();
    let param = { instanceId: data.instanceId };
    this.create.createModal(InstanceInfoViewComponent, param);
  }

  // 取消标注实体
  deleteEntity(){
    this.showEntityQuickMenu = false;
    this.data.entitys = this.data.entitys.filter(e => e.uuid != this.selectEntityUuid);
    this.data.relations = this.data.relations.filter(e => e.startNodeId !== this.selectEntityUuid && e.endNodeId !== this.selectEntityUuid);
    this.drawEntityRelation();
    // 保存json信息
    this.saveTaskMarkData();
  }

  // 展示取消标注实体关系对话框
  showNodeRelationBox(){
    this.showEntityQuickMenu = false;
    this.showNodeRelation = true;
  }

  // 关闭选择实体关系弹框
  cancelSelectRelation(state){
    if(state){
      this.selectRelationModal.toggle();
    }
    $('.tagItem.active').removeClass('active');
    this.startNode = null;
    this.endNode = null;
  }

  // 取消标注实体关系
  deleteRelation(index,uuid?){
    if(uuid){
      this.selectRelationUuid = uuid;
    }
    this.nodeRelations.splice(index, 1);
    this.showEntityQuickMenu = false;
    this.data.relations = this.data.relations.filter(e => e.uuid !== this.selectRelationUuid);
    this.selectRelationUuid = '';
    this.hoverRelationId = '';
    setTimeout(() => {
      this.drawRelation();
    }, 0);
    // 保存json信息
    this.saveTaskMarkData();
  }

  // 根据名称筛选关系
  filterRelations(){
    const i = $.trim(this.relationName);
    if(i){
      return this.relations.filter(e => e.attributeName.indexOf(i)>-1);
    }else{
      return this.relations;
    }
  }

  // 插入实体关系
  insertRelation(relation){
    let arr = [];
    let startMaterial:any = this.findInterval(this.startNode.start-1,this.contentList);
    arr.push({
      materialId: startMaterial.materialId,
      pageNum: startMaterial.pagesNum,
      sourceMaterial: startMaterial.materialTitle,
    });
    let endMaterial:any = this.findInterval(this.endNode.start-1,this.contentList);
    if(!(startMaterial.materialId == endMaterial.materialId && startMaterial.pagesNum == endMaterial.pagesNum)){
      arr.push({
        materialId: endMaterial.materialId,
        pageNum: endMaterial.pagesNum,
        sourceMaterial: endMaterial.materialTitle,
      });
    }
    const item = {
      tagType: 0,
      startNodeName: this.startNode['name'],
      endNodeName: this.endNode['name'],
      startNodeId: this.startNode.uuid,
      endNodeId: this.endNode.uuid,
      uuid: this.instanceModuleService.uuid2(),
      relationshipId: relation.id,
      relationName: relation.attributeName,
      relationAlias: relation.relationAlias,
      relationshipName: relation.name,
      reverseRelationAlias: relation.reverseRelationAlias,
      reverseRelationName: relation.reverseName,
      sourceList: arr
    };
    this.data.relations.push(item);
    setTimeout(() => {
      this.drawRelation();
    }, 0);
    // 保存json信息
    this.saveTaskMarkData();
    // 关闭关系选择框
    this.cancelSelectRelation(1);
    // 清除标签选中效果
    this.emptyActive();
    // 清空选中项
    this.startNode = null;
    this.endNode = null;
  }

  // 鼠标移入某条关系边
  mouseoverEvent(uuid){
    // this.hoverRelationId = uuid;
  }

  // 鼠标移出某条关系边
  mouseoutEvent(){
    // this.hoverRelationId = '';
  }

  // 鼠标移入某个实体标签
  mouseoverEvent1(uuid){
    // this.hoverTagId = uuid;
    // this.hoverRelationId = '';
  }

  // 鼠标移出某个实体标签
  mouseoutEvent1(){
    // this.hoverTagId = '';
  }

  // 关闭快捷菜单
  closeQuickMenu(){
    this.showEntityQuickMenu = false;
  }

  // 判断关系边的选中、灰掉状态
  judgeActive(type,item){
    if(this.filterConditions.type == -1){
      return true;
    }
    if(type == 'node'){
      // 标注清单展示类模块时，只展示选中概念的实体
      if(this.filterConditions.type == 0){
        if(this.filterConditions.instanceId){
          return item.tag.uuid == this.filterConditions.instanceId;
        }
        if(!this.filterConditions.conceptId){
          return item.tag.tagType == 0;
        }else{
          return item.tag.tagType == 0 && this.filterConditions.conceptId == item.tag.conceptId;
        }
      }
      else if(this.filterConditions.type == 1){
        // 只展示选中的关系属性边的起始和指向节点
        if(this.filterConditions.relationId){
          let relation = this.data.relations.find(e => e.uuid == this.filterConditions.relationId);
          if(relation){
            return relation.startNodeId == item.tag.uuid || relation.endNodeId == item.tag.uuid;
          }else{
            return false;
          }
        }
        else{
          if(!this.filterConditions.relationName){
            return true;
          }else{
            // 展示选中关系名称的起始及指向节点
            let relations = this.data.relations.filter(r => (r.startNodeId == item.tag.uuid || r.endNodeId == item.tag.uuid) && r.relationName == this.filterConditions.relationName);
            return relations.length > 0;
          }
        }
      }
    }

    // 判断是否显示关系边
    if(type == 'relation'){
      // 标注清单展示类模块时，不显示关系
      if(this.filterConditions.type == 0){
        return false;
      }
      else if(this.filterConditions.type == 1){
        // 只展示选中的关系属性边
        if(this.filterConditions.relationId){
          return this.filterConditions.relationId == item.uuid;
        }
        // 只展示选中的实体的关系属性
        else{
          if(!this.filterConditions.relationName){
            return true;
          }else{
            return this.filterConditions.relationName == item.relationName;
          }
        }
      }
    }
  }

  // 根据标注类型返回title文字内容
  getTitle(d){
    return d.tagType == 0 ? d.conceptName+'：“'+d.name+'”' : d.conceptName+'-'+d.attributeName+'：“'+d.name+'”';
  }

  // 显示第几页的文字
  getPage(i){
    if(this.pageArr.length == 0){
      return null;
    }
    let item = this.pageArr.find(e => e.rowI == i);
    if(item){
      return item.pageI + 1;
    }else{
      return null;
    }
  }

  // 文字内容定位到某一页
  toCurrentPage(event){
    if(event > this.pageArr.length - 1){
      return;
    }
    const rowI = this.pageArr[event].rowI;
    const el = document.getElementById('textRow-'+rowI);
    if(el){
      el.scrollIntoView(
        {
          behavior:'smooth',
          block: 'start'
        }
      );
      $('.lineDiv').css('display','none');
      $('#textRow-'+rowI+' .lineDiv').css('display','block');
    }
  }

  // 文字内容定位到某一行
  toCurrentRow(event){
    // 获取对应iddom
    let el = null;
    let rowI = 0;
    // 根据实体定位
    if(event.type == 0){
      let items = this.data.entitys.filter(e => e.name == event.name && e.conceptId == event.conceptId);
      items = items.sort((a,b) => {return a['start'] - b['start']});
      rowI = $("span[id^='entity-"+items[0].uuid+"']").eq(0).parents('.textRow').index();
      el = document.getElementById('textRow-'+rowI);
      this.hoverTagId = items[0].uuid;
      this.hoverRelationId = '';
    }
    // 根据关系定位
    else{
      let items = this.data.relations.filter(e => e.startNodeName == event.startNodeName && e.endNodeName == event.endNodeName && e.relationshipId == event.relationshipId);
      rowI = $("span[id^='entity-"+items[0].startNodeId+"']").eq(0).parents('.textRow').index();
      el = document.getElementById('textRow-'+rowI);
      this.hoverRelationId = items[0].uuid;
      this.hoverTagId = '';
    }
    // 判断进行平滑滚动
    if (el) {
      el.scrollIntoView(
        {
          behavior:'smooth',
          block: 'start'
        }
      );
      $('.lineDiv').css('display','none');
      $('#textRow-'+rowI+' .lineDiv').css('display','block');
    }
  }

  // 更新实体关系标注清单
  updateMarkList(){
    if(this.data.entitys.length == 0){
      this.textMarkList.instances = [];
      this.textMarkList.instanceRelations = [];
      return;
    }
    // 实体按照概念分组
    let data = this.data.entitys.filter(e => e.tagType == 0);
    const groupedData = this.groupByAttr(data,'conceptName');
    // 按实体名称去重，并统计数值
    let data1 = [];
    for(let k in groupedData){
      let i = this.concepts.find(c => c.conceptName == groupedData[k][0].conceptName);
      let item = {
        conceptName:k,
        conceptId:groupedData[k][0].conceptId,
        color: i ? i.bgColor : '#ccc',
        num:groupedData[k].length,
        instances:groupedData[k],
        showDetails: true
      };
      data1.push(item)
    }
    this.textMarkList.instances = data1;

    // 实体关系按照关系名称分组
    let rdata = this.data.relations;
    const rgroupedData = this.groupByAttr(rdata,'relationName');
    // 按实体关系名称去重，并统计数值
    let rdata1 = [];
    for(let k in rgroupedData){
      let item = {
        relationName:k,
        relationshipId:rgroupedData[k][0].relationshipId,
        num:rgroupedData[k].length,
        relations:rgroupedData[k],
        showDetails: true
      };
      rdata1.push(item)
    }
    this.textMarkList.instanceRelations = rdata1;
    console.log(data1,rdata1)
  }

  // 数组按照某个属性值分组
  groupByAttr(data,attrName){
    return data.reduce((acc, item) => {
      const key = item[attrName];
      if (!acc[key]) {
          acc[key] = [];
      }
      acc[key].push(item);
      return acc;
    }, {});
  }

  // 标注清单组件：选中类、实体、关系发生变化时，需设置节点、关系显示或隐藏；选中实体、关系时，需定位到对应位置
  textMarkListChange(event){
    this.filterConditions = event;
    $('.lineDiv').css('display','none');
    let el = null, rowI = 0;
    // 选中某个实体
    if(this.filterConditions.type == 0 && this.filterConditions.instanceId){
      if(this.data.entitys.find(e => e.uuid == this.filterConditions.instanceId)){
        rowI = $("span[id^='entity-"+this.filterConditions.instanceId+"']").eq(0).parents('.textRow').index();
        el = document.getElementById('textRow-'+rowI);
      }
    }
    // 选中某个关系属性
    if(this.filterConditions.type == 1 && this.filterConditions.relationId){
      let items = this.data.relations.filter(e => e.uuid == this.filterConditions.relationId)
      if(items.length > 0){
        rowI = $("span[id^='entity-"+items[0].startNodeId+"']").eq(0).parents('.textRow').index();
        el = document.getElementById('textRow-'+rowI);
      }
    }
    // 判断进行平滑滚动
    if (el) {
      el.scrollIntoView(
        {
          behavior:'smooth',
          block: 'start'
        }
      );
      $('#textRow-'+rowI+' .lineDiv').css('display','block');
    }
  }

  // 切换查看实体、关系
  selectRightTab(i){
    this.selectIndex = i;
    setTimeout(() => {
      this.textMarkList.emitData();
    }, 0);
  }

  // 保存标记信息
  saveTaskMarkData(){
    const obj = this.taskData.jsonStr? JSON.parse(this.taskData.jsonStr) : {};
    obj.result = this.data;
    const params = {
      "jsonStr": JSON.stringify(obj),
      "taskId": this.taskData.taskId
    }
    this.kmsService.updateKeResult(params).subscribe(
      res => {
        if (res.code == '200') {
          this.taskData.jsonStr = params.jsonStr;
          this.isCorrected = true;
        } else {
          this.message.waring(res.msg);
        }
      }
    );
  }

  textSlice(str,n){
    if(str.length < n){
      return str;
    }else{
      return str.slice(0,n)+'...';
    }
  }

  // 判断是否为已绑定的实体
  judgeSelectInstance(instanceId){
    const selectNode = this.data.entitys.find(e => e.uuid == this.selectEntityUuid);
    return selectNode.instanceId && selectNode.instanceId == instanceId;
  }

  // 点击发布到知识库
  clickPublish(){
    if(this.checkDisable()){
      return;
    }
    if(this.data.entitys.length == 0){
      this.message.info('当前任务下没有标注的实体，无法发布到知识库！');
      return;
    }
    this.trim.openCLick("当前任务下标注的实体关系是否已校对完成，确认发布到知识库吗？", (data) => {
      if (data) {
        this.kmsService.taskPublish(this.taskData.taskId).subscribe(
          res => {
            if(res.code == 200){
              this.message.success('操作成功，发布到知识库操作需要较长的时间，请耐心等待！');
              this.taskData.publishStatus = 2;
              this.editEnable = !this.checkDisable();
              this.operateState = 0;
            }else{
              this.message.waring(res.msg);
            }
          }
        );
        // 若没有人工校对，就发布到知识库，则需将合并后的抽取结果自动保存下
        const obj = this.taskData.jsonStr? JSON.parse(this.taskData.jsonStr) : {};
        if(!obj.result){
          this.saveTaskMarkData();
        }
      }
    })
  }

  // 点击进行实体融合
  clickEntityFusion(){
    if(this.checkDisable()){
      return;
    }
    let arr = [];
    const entitys = JSON.parse(JSON.stringify(this.data.entitys));
    entitys.forEach(e => {
      // 1.tagType == 0  当前标注的是类：将同概念、同名实体归纳到一起
      if(e.tagType == 0){
        // 判断当前实体是否已处理
        let c = arr.find(e1 => e1.conceptId == e.conceptId && e1.name == e.name && e1.tagType == 0);
        if(!c){
          // 获取同概念同名实体数量
          let items = entitys.filter(e1 => e1.conceptId == e.conceptId && e1.name == e.name && e1.tagType == 0);
          if(items.length > 1){
            let child = {
              name: e.name,
              conceptId: e.conceptId,
              conceptName: e.conceptName,
              tagType: 0,
              allSelected: false,
              collapse: false,
              entitys:[]
            };
            items.forEach(e1 => {
              // 获取实体名称出现位置的前后25个字符
              let desc = '';
              let start = e1.start - 1 - 25;
              start = start < 0? 0 : start;
              let end = e1.end - 1 + 25;
              end = end > this.taskData.fulltext.length ? this.taskData.fulltext.length : end;
              desc = this.taskData.fulltext.slice(start,end).replace(new RegExp(e.name, 'g'), `<span>${e.name}</span>`);
              child.entitys.push({
                uuid: e1.uuid,
                desc: desc,
                selected: false
              })
            })
            arr.push(child);
          }
        }
      }else{
        // 2.tagType == 1  当前标注的是属性：将同关系、同属性值的归纳到一起
        // 判断当前属性值是否已处理
        let c = arr.find(e1 => e1.conceptId == e.conceptId && e1.name == e.name && e1.attributeId == e.attributeId && e1.tagType == 1);
        if(!c){
          // 获取同关系、同属性值数量
          let items = entitys.filter(e1 => e1.conceptId == e.conceptId && e1.name == e.name && e1.attributeId == e.attributeId && e1.tagType == 1);
          if(items.length > 1){
            let child = {
              name: e.name,
              conceptId: e.conceptId,
              conceptName: e.conceptName,
              attributeId: e.attributeId,
              attributeName: e.attributeName,
              tagType: 1,
              allSelected: false,
              collapse: false,
              entitys:[]
            };
            items.forEach(e1 => {
              // 获取实体名称出现位置的前后25个字符
              let desc = '';
              let start = e1.start - 1 - 25;
              start = start < 0? 0 : start;
              let end = e1.end - 1 + 25;
              end = end > this.taskData.fulltext.length ? this.contentList.length : end;
              desc = this.taskData.fulltext.slice(start,end).replace(new RegExp(e.name, 'g'), `<span>${e.name}</span>`);
              child.entitys.push({
                uuid: e1.uuid,
                desc: desc,
                selected: false
              })
            })
            arr.push(child);
          }
        }
      }
    });
    this.sameEntityArr = arr;
    if(this.sameEntityArr.length == 0){
      this.message.info('暂无同名实体需要融合！');
    }else{
      this.operateState = 1;
    }
  }

  // 确认进行实体融合
  entityFunsion(){
    let arr = [];
    this.sameEntityArr.forEach(e => {
      const entitys = e.entitys.filter(e1 => e1.selected);
      if(entitys.length >= 2){
        arr.push(entitys);
      }
    });
    if(arr.length == 0){
      this.message.info('每个同名实体下至少要选择两条数据才能进行融合！');
      return;
    }
    // 同名实体融合:以每个同名实体下的第一条数据为基准，将其他同名实体下的数据合并到该条数据中
    arr.forEach(e => {
      const uuids = e.filter((e1,i) => i > 0).map(e1 => e1.uuid);
      // 1.实体融合
      this.data.entitys = this.data.entitys.filter(e1 => !uuids.includes(e1.uuid));
      // 2.更新关系数据的起始节点及指向节点id
      this.data.relations.forEach(e1 => {
        if(uuids.includes(e1.startNodeId)){
          e1.startNodeId = e[0].uuid;
        }
        if(uuids.includes(e1.endNodeId)){
          e1.endNodeId = e[0].uuid;
        }
        if(e1.tagType == 0){
          let arr = [];
          const startNode = this.data.entitys.find(e2 => e2.uuid == e1.startNodeId);
          let startMaterial:any = this.findInterval(startNode.start-1,this.contentList);
          arr.push({
            materialId: startMaterial.materialId,
            pageNum: startMaterial.pagesNum,
            sourceMaterial: startMaterial.materialTitle,
          });
          const endNode = this.data.entitys.find(e2 => e2.uuid == e1.endNodeId);
          let endMaterial:any = this.findInterval(endNode.start-1,this.contentList);
          if(!(startMaterial.materialId == endMaterial.materialId && startMaterial.pagesNum == endMaterial.pagesNum)){
            arr.push({
              materialId: endMaterial.materialId,
              pageNum: endMaterial.pagesNum,
              sourceMaterial: endMaterial.materialTitle,
            });
          }
          e1.sourceList = arr;
        }
      })
    });
    // 3.判断两个实体间是否重复创建某个关系，有则进行合并
    let rArr = [];
    this.data.relations.forEach(e => {
      // 判断是否已经存在该关系
      let c = rArr.find(e1 => e1.startNodeId == e.startNodeId && e1.endNodeId == e.endNodeId && e1.relationshipId == e.relationshipId);
      if(!c){
        rArr.push(e);
      }
    })
    this.data.relations = rArr;
    this.drawEntityRelation();
    // 保存json信息
    this.saveTaskMarkData();  
    this.operateState = 0;
    this.message.info('实体融合成功！');
  }

  // 取消融合
  cancelFusion(){
    this.operateState = 0;
  }

  // 实体融合 全选或取消
  allSelectOrCancel(i1){
    this.sameEntityArr.forEach((e,i) => {
      if(i == i1){
        e.allSelected = !e.allSelected;
        e.entitys.forEach((e1) => {
          e1.selected = e.allSelected;
        })
      }
    })
  }

  // 实体融合 选择或取消单条
  selectOrCancel(i1,i2){
    this.sameEntityArr[i1].entitys[i2].selected = !this.sameEntityArr[i1].entitys[i2].selected;
    const len = this.sameEntityArr[i1].entitys.filter(e => e.selected).length;
    if(len < this.sameEntityArr[i1].entitys.length){
      this.sameEntityArr[i1].allSelected = false;
    }else{
      this.sameEntityArr[i1].allSelected = true;
    }
  }

  // 点击折叠或展开下级
  clickCollapse(i){
    event.stopPropagation();
    this.sameEntityArr[i].collapse = !this.sameEntityArr[i].collapse;
  }

  checkDisable(){
    // 抽取完成且待发布、或发布到知识库失败时，才可进行知识融合、实体关系标注、同步到知识库等操作
    if(this.taskData.status == 3 && (this.taskData.publishStatus == 1 || this.taskData.publishStatus == 4)){
      return false;
    }else{
      return true;
    }
  }
}
